import api from "../api";

export const MeetingMConfService = {
  createMeeting: async (hearingFileId: number) => {
    if (!hearingFileId) {
      return { status: false, message: "hearingFileId é obrigatório" };
    }

    try {
      const { data } = await api.post(
        `/v1/MeetingMConf/CreateMeeting?hearingFileId=${hearingFileId}`,
      );
      return { status: true, data: data?.data ?? data };
    } catch (error: any) {
      return {
        status: false,
        message: error?.response?.data?.message || "Erro ao iniciar gravação.",
      };
    }
  },
  endMeeting: async (hearingFileId: number) => {
    if (!hearingFileId) {
      return { status: false, message: "hearingFileId é obrigatório" };
    }

    try {
      const { data } = await api.get(
        `/v1/MeetingMConf/EndMeeting?hearingFileId=${hearingFileId}`,
      );
      return { status: true, data: data?.data ?? data };
    } catch {
      return {
        status: false,
        message: "Erro ao encerrar gravação.",
      };
    }
  },
  joinMeeting: async (hearingFileId: number) => {
    try {
      const { data } = await api.post(
        `/v1/MeetingMConf/JoinMeeting?hearingFileId=${hearingFileId}`,
      );
      return { status: true, data: data?.data ?? data };
    } catch {
      return {
        status: false,
        message: "Erro ao iniciar gravação.",
      };
    }
  },
  getLinkRecording: async (
    customerId: number | string,
    hearingFileId: number | string,
  ) => {
    if (!customerId || !hearingFileId) {
      return {
        status: false,
        message: "Parâmetros obrigatórios não informados.",
      };
    }

    try {
      const { data } = await api.get(
        `/v1/MeetingMConf/GetLinkRecording?customerId=${customerId}&hearingFileId=${hearingFileId}`,
      );

      return { status: true, data: data?.data ?? data };
    } catch {
      return {
        status: false,
        message: "Erro ao obter link da gravação.",
      };
    }
  },
};
